import axios from 'axios';
import { of , from } from 'rxjs';

import { map, mergeMap } from 'rxjs/operators';
import queryString from 'querystring';
import { MOVIE_DB_API_URL, MOVIE_DB_API_KEY } from 'app/constants/MoviesConstants';
import camelCaseRecursive from 'camelcase-keys-recursive';

function movieDBRequest(method, path, query = {}) {
  const queryStr = queryString.stringify({ ...query, api_key: MOVIE_DB_API_KEY });

  return from(axios[method](`${MOVIE_DB_API_URL}${path}?${queryStr}`)).pipe(
    map(res => {
      res.data = camelCaseRecursive(res.data);
      return res;
    })
  );
}

function searchMovies(title, page = 1) {
  // https://developers.themoviedb.org/3/search/search-movies
  return movieDBRequest('get', '/search/movie', {
    language: 'en-US',
    include_adult: false,
    query: title,
    page
  });
}

function getMovieById(movieId) {
  // https://developers.themoviedb.org/3/movies/get-movie-details
  return movieDBRequest('get', `/movie/${movieId}`, {
    language: 'en-US',
    append_to_response: 'videos,credits'
  });
}

function getMovieByTitle(title) {
  return searchMovies(title).pipe(
    mergeMap(res => {
      if (res.data.results && res.data.results.length) {
        return getMovieById(res.data.results[0].id);
      }

      return of({});
    })
  );
}

export default {
  searchMovies,
  getMovieById,
  getMovieByTitle
};
